import { render, staticRenderFns } from "./student.vue?vue&type=template&id=7281acbc&"
import script from "./student.vue?vue&type=script&lang=ts&"
export * from "./student.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "student.vue"
export default component.exports